import { render, staticRenderFns } from "./powerManage copy.vue?vue&type=template&id=252b6aa8&scoped=true&"
import script from "./powerManage copy.vue?vue&type=script&lang=js&"
export * from "./powerManage copy.vue?vue&type=script&lang=js&"
import style0 from "./powerManage copy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./powerManage copy.vue?vue&type=style&index=1&id=252b6aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b6aa8",
  null
  
)

export default component.exports